import { render, staticRenderFns } from "./FutureInput.vue?vue&type=template&id=d06131d4&"
import script from "./FutureInput.vue?vue&type=script&lang=js&"
export * from "./FutureInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports